import { configureStore } from "@reduxjs/toolkit";
import api from "./api";
import authState from "./slices/auth";

export const store = configureStore({
  reducer: {
    auth: authState,
    [api.reducerPath]: api.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(api.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
